import React, { Fragment } from 'react';

import ReactTooltip from 'react-tooltip';

export interface TooltipProp {
  children: JSX.Element;
  content: JSX.Element;
  place: 'top' | 'right' | 'bottom' | 'left';
}

export const Tooltip = ({ children, place, content }: TooltipProp) => (
  <>
    <div data-tip={content}>{children}</div>
    <ReactTooltip
      effect='float'
      delayShow={100}
      place={place}
      backgroundColor='gray'
      textColor='white'
      borderColor='black'
    />
  </>
);
